import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Subscription} from "rxjs";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { FileSystemService } from "../../../../swaggerServices/api/fileSystem.service";
import { RubixDocumentsService} from "../../tax-returns/tax-return/rubix-documents/rubix-documents.service";

interface IConfigFolderObjects {
  id?: string;
  name?: string;
  url?: string;
  count?: string;
  wstype?: string;
  edit_date?: string;
}

interface IConfigFolders {
  folders?: IConfigFolderObjects[];
}

@Component({
    selector: 'app-archived-configs',
    templateUrl: './archived-configs.component.html',
    styleUrls: ['./archived-configs.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'tax-returns', alias: 'taxReturns' },
        }
    ],
    standalone: false
})
export class ArchivedConfigsComponent implements OnInit {
  subscriptions: Subscription[] = [];
  baseFolder: boolean = true;
  folderId: string = "configFolders";
  folderType: string = "root";
  folderLinksLoaded: boolean = false;
  rootFolder: string;
  tempFolder: string;
  finalFolder: string;
  pathSeparator: string;
  propertyVisibility = {
    sortBy: true,
    fileType: false,
    layout: false,
    selectAll: false,
    newFolder: false,
    uploadDocument: false,
    downloadDocument: true,
  };
  fileStoreType:string = "configExports"

  constructor(
    private fileSystemService: FileSystemService,
    public rubixDocumentsService: RubixDocumentsService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.rubixDocumentsService.setFileStoreType(this.fileStoreType);
    this.rubixDocumentsService.setPropertyVisibility(this.propertyVisibility);
    this.refreshDocumentFolder();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private refreshDocumentFolder() {
    this.rubixDocumentsService.getRootConfigFolderDetails({baseFolder: true, folderId: this.folderId})
  }
}
